<template>
  <div class="loader">
    <v-progress-circular
      indeterminate
      color="var(--color-grey10)"
      :size="size"
      :width="width"
    />
    <div v-if="text" class="text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: { type: String, default: '' },
    size: { type: Number, default: 32 },
    width: { type: Number, default: 4 },
  },
}
</script>
<style scoped>
.loader {
  text-align: center;
}

.text {
  color: var(--color-tertiary);
  margin-top: 0.4em;
}
</style>
